module.exports = __webpack_public_path__ + "img/multiplier1_normal.6512f476.png";